// Copyright (c) Docugami, Inc. All rights reserved.

import { ReportBindingEvaluationPreview } from "networking/reportsApi"
import { useGetEvaluationQuery } from "store/reports/reportsSlice";
import { skipToken } from "@reduxjs/toolkit/dist/query/react";
import { selectReportId } from "store/reports/selectors";
import { useAppSelector } from "./redux";

export const useBindingEvaluationData = (evaluation?: ReportBindingEvaluationPreview): [boolean | undefined, string | undefined] => {
    const reportId = useAppSelector(selectReportId);

    const isPreview = !!evaluation?.isPreview;
    const { isLoading: isLoadingFullEvaluation, data } = useGetEvaluationQuery(isPreview ? { reportId: reportId, evaluationId: evaluation!.id } : skipToken);

    const isLoading = isPreview ? isLoadingFullEvaluation : (evaluation === undefined ? undefined : false);
    const content = isPreview ? data?.richTextValue : evaluation?.richTextValue;
    return [isLoading, content]
}
